import { FormProjectField } from '../../api/shared'
import React, { FC } from 'react'
import { css } from '@emotion/css'
import { IconClose } from '@contrast-security-inc/design-system-foundations'

interface DeleteJiraFieldButtonProps {
  field: FormProjectField
  fieldIndex: number
  removeField: (index: number) => void
}
export const DeleteJiraFieldButton: FC<DeleteJiraFieldButtonProps> = ({
  field,
  fieldIndex,
  removeField
}) => {
  return (
    <div
      className={css`
        position: absolute;
        right: -30px;
        width: 20px;
        height: 35px;
        display: flex;
        align-items: center;
      `}
    >
      {!field._projectField?.required && (
        <span
          data-testid={`delete-jira-field-button-${fieldIndex}`}
          className={css`
            display: flex;
            :hover {
              cursor: pointer;
            }
          `}
          onClick={() => removeField(fieldIndex)}
        >
          <IconClose size="sm" color="neutral50" />
        </span>
      )}
    </div>
  )
}
